import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToHashElement() {

    const positionMap = {
        "about-us": "center",
        "contact-us": "end",
        "our-project": "end",
    }

    const { hash } = useLocation();
    const HEADER_HEIGHT = 250; // Your fixed header height

    useEffect(() => {
        if (hash) {
            const elementId = hash.replace('#', '');
            const element = document.getElementById(elementId);

            if (element) {
                // Wait for DOM to finish rendering
                setTimeout(() => {
                    // 1. Get the element's distance from the top of the viewport
                    const elementPosition = element.getBoundingClientRect().top;

                    // 2. Add current window scroll position to get absolute page position
                    const offsetPosition = elementPosition + window.pageYOffset - HEADER_HEIGHT;

                    // 3. Scroll to the calculated position
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }, 0);
            }
        }
    }, [hash]); // Runs every time the URL hash changes

    return null; // This component does not render any visual UI
}
